export default {
  time: {
    crud: {
      create_overtime: "Überstundenantrag erstellen"
    },
    event: {
      clock_in: "Clock In",
      clock_out: "Clock Out",
      duty_in: "Dienst In",
      training_in: "Ausbildung in",
      training_out: "Ausbilden",
      home_duty_in: "Startseite Clock In",
      duty_out: "Dienst Out",
      home_duty_out: "Startseite Clock  Out",
      break_in: "Pause In",
      break_out: "Pause Out",
      lunch_in: "Mittagspause In",
      lunch_out: "Mittagspause Out"
    },
    menu: {
      shifts: "Schichten",
      timesheets: "Timesheets",
      overtime_requests: "Überstundenanträge",
      overtime_approval: "Antrag auf Bestätigung der Überstunden",
      employee_calendar: "Employee Calendar"
    },
    shift_types: {
      FIX: "gesetzt",
      FLEXIBLE: "flexibel",
      OFF_DAY: "freier Tag",
      OFFDAY: "freier Tag",
      HOLIDAY: "Feiertag",
      WORKDAY: "Arbeitstag",
      BREAK: "Ruhetag",
      OVERTIME: "Overtime",
      OVERTIME_SHIFT: "Overtime"
    },
    overtime_approval: {
      employee: "Mitarbeiter",
      workplan: "Arbeitsplan",
      request_status: "Antragsstatus",
      reason: "Vernunft",
      request_time: "Antragsdatum",
      approval_message:
        "Do you want to approve {0}'s request for {2} minutes of <span class='red--text font-weight-bold'>{3}</span> overtime for his/her shift on {1}?",
      shift_type: {
        workday: "Workday",
        offday: "Offday work",
        holiday: "Holiday work"
      },
      overtime_approval: "Overtime Approval"
    },
    overtime_request: {
      approve_title: "Bestätigung des Überstundenantrags",
      add_overtime: "Überstundenantrag hinzufügen",
      date: "Schichtdatum",
      workplan: "Schicht",
      overtime_in_minutes: "Dauer der Überstunden",
      short_minute: "min",
      request_status: "Status",
      request_date: "Antragsdatum",
      period: "Zeitraum",
      periods: {
        CLOCK_IN: "Clock In",
        CLOCK_OUT: "Clock Out",
        CLOCK_IN_OUT: "Clock In Out"
      },
      message: "{0} Möchten Sie die Überstundenanzahl von <b> {2} Minuten für die Schicht vom {1}  </b> bestätigen?"
    },
    timesheet: {
      employee: "Mitarbeiter",
      employees: "Mitarbeiter",
      date: "Datum",
      type: "Typ",
      work_plan: "Arbeitsplan",
      shift: "Schicht",
      clock_in: "Clock In",
      clock_in_title: "Clock In Zeit",
      late: "zu spät",
      reason: "Vernunft",
      late_title: "zu spät IN",
      it: "IT",
      it_title: "Identiätstyp",
      terminal: "Terminal",
      clock_out: "Clock Out",
      clock_out_title: "Clock Out Zeit",
      early: "zu früh",
      early_title: "zu früh OUT",
      ewt: "EAZ",
      ewt_title: "erwartete Arbeitszeit",
      awt: "TAZ",
      twt_title: "tatsächliche Arbeitszeit",
      twt: "TAZ",
      awt_title: "tatsächliche Arbeitszeit",
      ot: "ÜS",
      ot_title: "Überstunden",
      mt: "FZ",
      mt_title: "Fehlzeiten",
      name: "Mitarbeiter",
      time: "Zeit",
      identity_type: "Identitätstyp",
      event_type: "Event Typ",
      event_time: "Event Zeit",
      all_events: "Alle Events",
      status: "Status",
      shift_name: "Schicht Name",
      branch: "Bereich",
      unit: "Unit",
      team: "Team",
      jobInfo: "Job Info",
      staffNumber: "Personalnummer",
      information: {
        work_day: "Arbeitstag",
        work_day_desc: "Der Mitarbeiter wird an diesem Tag zum Dienst erscheinen.",
        work_off: "Ruhetag",
        work_off_desc: "Dieser Tag ist ein freier Tag es Mitarbeiters.",
        public_holiday: "gesetzlicher Feiertag",
        public_holiday_desc: "Dies ist ein gesetzlicher Feiertag.",
        did_not_come_to_work: "Nicht zur Arbeit erschienen",
        did_not_come_to_work_desc:
          "Trotz zugeteilter Schicht ist der Mitarbeiter an diesem Tag nicht zur Arbeit erschienen.",
        on_leave: "im Urlaub",
        on_leave_desc: "Der Mitarbeiter ist an diesem Tag im Urlaub.",
        calculated: "errechnet",
        calculated_desc: "Die grünmarkierten Bereiche sind erfolgreich berechnet worden.",
        not_calculated: "nicht errechnet",
        not_calculated_desc: "Die rotmarkierten Bereiche sind noch nicht berechnet worden."
      },
      total: "Total"
    },
    calendar: {
      holiday: "Holiday",
      off_day: "Off Day",
      breakday: "Break Day",
      employee_overtime: "If the employee comes to work on this date, it is calculated as overtime",
      employee_off_day: "It is the employee's weekly holiday",
      employee_break_day: "It is the employee's rest day.",
      shift_loading: "Idenfit creating shifts",
      create_shift: "Create Shift",
      shift_detail: "Shift Detail",
      leave_type: "Time Off Type",
      begin_time: "Begin Time",
      end_time: "End Time",
      break_time: "Break Time",
      shift_time: "Shift Time",
      clock_in_max_overtime: "Clock In Max Overtime",
      clock_out_max_overtime: "Clock Out Max Overtime",
      lately_tolerance: "Late Tolerance",
      early_tolerance: "Early Time Off Tolerance",
      overtime: "Overtime",
      early_clock_out_tolerance: "Late Tolerance",
      lately_clock_in_tolerance: "Early Time Off Tolerance",
      max_clock_in_overtime_in_minutes: "Clock In Max Overtime",
      max_clock_out_overtime_in_minutes: "Clock Out Max Overtime",
      shift_type: "Shift Type",
      count_as_overtime: "Count as overtime",
      total_work_time: "Total Working Time",
      selectWeekends: "Weekend Days",
      selectBreaks: "Break Days",
      overtime_request: {
        approve_title: "Approving Overtime",
        add_overtime: "Request Overtime ",
        detail_overtime: "Overtime Detail",
        date: "Shift Date",
        workplan: "Shift",
        overtime_in_minutes: "Shift Time",
        request_status: "Status",
        request_date: "Request Date",
        approval_date: "Approving Date",
        period: "Period",
        history: "Approving History",
        periods: {
          CLOCK_IN: "Clock In",
          CLOCK_OUT: "Clock Out",
          CLOCK_IN_OUT: "Clock In & Out"
        },
        approved:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini onaylamak istiyor musunuz ?",
        rejected:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini reddetmek istiyor musunuz ?",
        approval_to_manager: "Fazla Mesai Yöneticisine onay gitsin",
        not_approval_to_manager: "Fazla Mesai Yöneticisine onay gitmesin",
        pending_approval_manager: "Onayı Beklenen Yönetici",
        processes: {
          approved: "Approved the request",
          pending: "Pending approval",
          stopped: "Approving process stopped since the request cancelled",
          waiting: "Waiting for previous manager to approve",
          denied: "Request cancelled"
        }
      },
      multiple_shift_deleting: "Multiple Shift Deleting"
    },
    max_overtime_in_minutes_warning_message:
      "Your overtime request and assigned shift exceeds 11 hour, beucase of that your request is not created",
    totalWorkingTimeInMinutes: "Total Working Time"
  }
};
